export default __webpack_public_path__ + "static/media/radar_swiping.59c0698a.wav";